export default [
  {
    key: 'branchOfficeName',
    label: '支店',
    style: {
    }
  }, 
  {
    key: 'departmentName',
    label: '部署',
    style: {
    }
  }, 
  {
    key: 'approvalDate',
    label: '未承認日',
    style: {
    }
  }, 
  {
    key: 'name',
    label: '社員名',
    style: {
    }
  }, 
  {
    key: 'actions',
    label: '',
    style: {
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/roumu/listHeader.js